export default __webpack_public_path__ + "static/media/e-lab-graphic.b16e347c.svg";